<div class="dialog-container" style="padding: 16px; box-sizing: border-box; overflow-x: hidden;">
    <h2 mat-dialog-title>{{ isEditMode ? 'Edit' : 'Add' }} {{ entityType === 'user' ? 'User' : 'Company' }} License</h2>
    <mat-dialog-content style="padding: 12px 0; margin: 0;">
        <form [formGroup]="licenseForm">
            <div class="row g-0">
                <div class="col-12">
                    <mat-form-field appearance="outline" floatLabel="always" style="width: 100%;">
                        <mat-label>License Number</mat-label>
                        <input matInput formControlName="stateLicenseNumber">
                    </mat-form-field>
                </div>
                <div class="col-12">
                    <lgv-state-dropdown 
                        [control]="stateControl" 
                        [required]="true" 
                        [disabled]="isEditMode" 
                        [states]="allStates">
                    </lgv-state-dropdown>
                </div>
                <div class="col-12">
                    <mat-form-field appearance="outline" floatLabel="always" style="width: 100%;">
                        <mat-label>Expiration Year</mat-label>
                        <input matInput [matDatepicker]="picker" formControlName="expirationYear" readonly>
                        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                        <mat-datepicker #picker startView="multi-year" (yearSelected)="chosenYearHandler($event)"></mat-datepicker>
                        <mat-error *ngIf="licenseForm.get('expirationYear').errors?.required">Expiration year is required</mat-error>
                    </mat-form-field>
                </div>
                <div class="col-12">
                    <mat-form-field appearance="outline" floatLabel="always" style="width: 100%;">
                        <mat-label>Status</mat-label>
                        <mat-select formControlName="status" required>
                            <mat-option *ngFor="let status of statuses" [value]="status">{{status}}</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>
        </form>
    </mat-dialog-content>
    <mat-dialog-actions align="end" style="margin: 8px 0 0 0; padding: 8px 0;">
        <button type="button" class="btn btn-secondary me-2" (click)="onCancel()">Cancel</button>
        <button type="button" class="btn btn-primary" (click)="onSave()" [disabled]="licenseForm.invalid || isSubmitting">
            {{isEditMode ? 'Update' : 'Add'}}
        </button>
    </mat-dialog-actions>
</div> 